import React, { useState, useMemo } from 'react';
import { draftModel } from "../../../models/draft";
import { useStoreActions } from "../../../store/store-context";
import { handlePromise } from "../../../infra/utils";
import { ConfirmationModal, useOverlayContext } from 'seagull';
import isEqual from 'lodash/isEqual';
export default function DraftUpdateModal(props) {
  const {
    changeDraftInRow,
    renderContent,
    dismissModal,
    width,
    shouldSubmit = () => true
  } = props;
  const [draft, setDraft] = useState(props.draft);
  const [loading, setLoading] = useState(false);
  const {
    api
  } = useStoreActions();
  const {
    showErrorToast
  } = useOverlayContext();
  const isDirty = useMemo(() => !isEqual(draft, props.draft), [draft, props.draft]);
  const {
    title,
    testid,
    content
  } = renderContent({
    draft,
    setDraft
  });
  async function submit() {
    if (!shouldSubmit(draft)) {
      return;
    }
    setLoading(true);
    const result = await handlePromise(api.draft.save(draftModel.toDTO(draft)));
    setLoading(false);
    if (result.success) {
      changeDraftInRow(draft);
      dismissModal();
    } else {
      showErrorToast('Failed to update draft', 'update-draft-error');
    }
  }
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: title,
    "data-testid": testid,
    content: content,
    width: width,
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    onCloseButtonClick: dismissModal,
    onSecondaryButtonClick: dismissModal,
    onPrimaryButtonClick: submit,
    primaryButtonDisabled: !isDirty,
    primaryButtonLoading: loading,
    primaryButtonTestid: "".concat(testid, "-confirm")
  });
}